export default "__VITE_ASSET__Cdlc3Ori__"